module.exports = __webpack_public_path__ + "static/hero-paper-right-0677f4aefda51f88e76f986bb886f652.webp";